import React, { useState } from 'react';
import { FaHotel, FaCar, FaPlane, FaCalendarAlt, FaShoppingBag, FaHome, FaEnvelope, FaUser, FaListAlt } from 'react-icons/fa';
import { BiSupport } from "react-icons/bi";
import Select from 'react-select';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { MdLocationOn, MdOutlineEmail, MdSend, MdTimer } from 'react-icons/md';
import { createContact } from '../../actions/request/ContactRequest';
import { maxLengthLitte, maxLengthLong } from '../../utils/dataApi/dataFormApi';
import { LuPhone } from 'react-icons/lu';
import { IoMdArrowRoundForward } from 'react-icons/io';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa6';

const categories = [
    { value: 'hotel', label: 'Hôtels' },
    { value: 'voiture', label: 'Location de voitures' },
    { value: 'vol', label: 'Billets d\'avion' },
    { value: 'activites', label: 'Activités et excursions' },
    { value: 'croisiere', label: 'Croisières' },
    { value: 'villa', label: 'Location de villas' },
    { value: 'train', label: 'Billets de train' },
    { value: 'camping', label: 'Camping et aventure' },
    { value: 'restaurant', label: 'Restaurants' },
    { value: 'spa', label: 'Spas et bien-être' },
    { value: 'transport', label: 'Transports privés' },
    { value: 'guide', label: 'Guides touristiques' },
    { value: 'parc', label: 'Parcs d\'attractions' },
    { value: 'yacht', label: 'Location de yachts' },
    { value: 'ecotourisme', label: 'Écotourisme' },
    { value: 'evenement', label: 'Événements et conférences' },
    { value: 'sport', label: 'Expériences sportives' },
    { value: 'cinema', label: 'Cinémas et spectacles' },
    { value: 'shopping', label: 'Shopping et lifestyle' },
];

const services = [
    { icon: <FaHotel size={24} />, text: "Réservation d'hôtels" },
    { icon: <FaCar size={24} />, text: "Location de voitures" },
    { icon: <FaPlane size={24} />, text: "Billets d'avion" },
    { icon: <FaCalendarAlt size={24} />, text: "Événements et conférences" },
    { icon: <FaShoppingBag size={24} />, text: "Shopping et lifestyle" },
    { icon: <FaHome size={24} />, text: "Location de vacances" }
];


const MAX_MESSAGE_LENGTH = maxLengthLong;  // 🔹 Limite du message
const MAX_NAME_LENGTH = maxLengthLitte;  // 🔹 Limite du nom




const ContactPage = () => {
    const dispatch = useDispatch();
    const loadingContact = useSelector((state) => state?.contacts?.loadingContact);

    const { quill, quillRef } = useQuill();

    // State global pour récupérer toutes les entrées utilisateur
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        category: '',
        message: ''
    });

    // Limite la taille du champ Nom complet
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "name" && value.length > MAX_NAME_LENGTH) {
            toast.error("Vous avez atteint la limite de caractère recommandé", { position: "bottom-right" })
            return;  // Empêche d'ajouter plus de caractères
        }

        setFormData({
            ...formData,
            [name]: value
        });
    };


    // Gère la sélection de catégorie
    const handleCategoryChange = (selectedOption) => {
        setFormData({
            ...formData,
            category: selectedOption
        });
    };

    // Gère l'envoi du formulaire
    const handleSubmit = () => {
        // e.preventDefault();

        const messageText = quill ? quill.root.innerText : "";
        // Met à jour le message avec Quill si l'éditeur est initialisé


        // 🔹 Vérification de la longueur du message
        if (messageText.length > MAX_MESSAGE_LENGTH) {
            toast.error(`Le message ne doit pas dépasser ${MAX_MESSAGE_LENGTH} caractères`, { position: "bottom-right" });
            return;
        }

        if (!formData.name || !formData.email || !formData.message) {
            toast.error("Veuillez remplir tous les champs", { position: "bottom-right" });
            return;
        }

        const formDataSend = {
            name: formData?.name,
            email: formData?.email,
            // category: formData?.category || "",
            message: formData?.message,
        }

        dispatch(createContact(formDataSend))

        // console.log("📩 Données envoyées :", formData);
        // alert("Votre message a été envoyé avec succès !");
    };



    return (
        <div style={{ overflow: "hidden" }}>
            <div className="container-fluid" >
                <div className="container" style={{ padding: "200px 20px 100px 20px" }}>

                    <div className="row">

                        <div className="col-md-6">
                            <div>
                                <div><h2 style={{ color: "#737373", fontSize: "43px" }}>Contactez nous </h2></div>
                                <div className="py-5"><p style={{ color: "#A6A6A6" }}>Votre avis compte ! Aidez-nous à améliorer nos services en partageant vos commentaires et suggestions.</p></div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div className="py-2 mt-2">
                                        <div><MdOutlineEmail color={"#43B613"} /> <a href="mailto:rezaplus2024@gmail.com" className="text-decoration-none" style={{ color: "#808080" }}>rezaplus2024@gmail.com</a></div>
                                    </div>
                                    <div className="py-2">
                                        <div><LuPhone color={"#43B613"} /> <a href="tel:223541895176" className="text-decoration-none" style={{ color: "#808080" }}>+213 541895176</a></div>
                                    </div>
                                    {/* <div className="py-2">
                                        <div><MdTimer color={"#43B613"} /> <a href="#" className="text-decoration-none" style={{ color: "#808080" }}>Service ouvert 24h/24</a></div>
                                    </div> */}
                                    
                                </div>
                                <div className="pt-5" style={{ display: "flex" }}>
                                    <div className="m-4 p-1" style={{ background: "#43B613", border: "2px #43B613 solid", color: "white" }}><a href="#"><FaLinkedinIn color={"white"} size={25} /></a></div>
                                    <div className="m-4 p-1" style={{ background: "white", border: "2px #43B613 solid", color: "white" }}><a href="#"><FaTwitter color={"#43B613"} size={25} /></a></div>
                                    <div className="m-4 p-1" style={{ background: "white", border: "2px #43B613 solid", color: "white" }}><a href="#"><FaFacebookF color={"#43B613"} size={25} /></a></div>
                                    <div className="m-4 p-1" style={{ background: "white", border: "2px #43B613 solid", color: "white" }}><a href="#"><FaInstagram color={"#43B613"} size={25} /></a></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div>
                                <div className="shadow-lg">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d204572.62842688814!2d2.9717380365666544!3d36.75983508134224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128fad6795639515%3A0x4ba4b4c9d0a7e602!2zQWxnZXIsIEFsZ8Opcmll!5e0!3m2!1sfr!2sci!4v1747994006258!5m2!1sfr!2sci" width="600" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14416666.882889977!2d1.665694299999999!3d28.094873449999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd7e8a6a28037bd1%3A0x7140bee3abd7f8a2!2zQWxnw6lyaWU!5e0!3m2!1sfr!2sci!4v1745081277375!5m2!1sfr!2sci" width="600" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                                </div>
                                <div className="pt-5">
                                    <a href="https://maps.app.goo.gl/iEouHs2ht6sm1HnK8" target='_blank' className="text-decoration-none" style={{ padding: "20px 30px 20px 30px", color: "white", background: "#43B613" }}>
                                        Naviguer sur Google Maps.
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>


            <div className="container-fluid bg-dark" style={{ position: "relative", padding: "100px 20px 100px 20px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-9" style={{ position: "relative", zIndex: 60 }}>
                            <div className="row">
                                <div className="col-md-6 p-3">
                                    <label className="text-white"> Nom complet *</label>
                                    <div>
                                        <input type="text" onChange={handleChange} name="name" className="text-dark" style={{ background: "white", padding: "10px 10px 10px 10px", borderRadius: "20px", width: "100%", border: "1px black solid" }} />
                                    </div>
                                </div>
                                <div className="col-md-6 p-3">
                                    <label className="text-white"> Email *</label>
                                    <div>
                                        <input type="text" onChange={handleChange} name="email" className="text-dark" style={{ background: "white", padding: "10px 10px 10px 10px", borderRadius: "20px", width: "100%", border: "1px black solid" }} />
                                    </div>
                                </div>
                                {/* <div className="col-md-4 p-3">
                                    <label className="text-white"> Sujet *</label>
                                    <div>
                                        <select class="form-select" onChange={handleChange} name="category" aria-label="Default select example" style={{ background: "white", padding: "10px 10px 10px 10px", borderRadius: "20px", width: "100%", border: "1px black solid" }}>
                                        <option value="">-- Veillez selectionner --</option>
                                        {categories.map((item) => {
                                                return (
                                                    <option value={item.value}>{item.label}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div> */}
                                <div className="col-md-12 p-3">
                                    <label className="text-white"> Votre message *</label>
                                    <div>
                                        <textarea rows={3} onChange={handleChange} name="message" className="text-dark" style={{ background: "white", padding: "10px 10px 10px 10px", borderRadius: "20px", width: "100%", border: "1px black solid" }} />
                                    </div>
                                </div>

                                <div className=" p-3">
                                    <div style={{ width: "100%", display: "flex", justifyContent: "start" }}>
                                        <div>
                                            {
                                                loadingContact ?
                                                    (
                                                        <button type="button" rows={3} className="text-dark" style={{ background: "white", fontWeight: "bold", padding: "10px 10px 10px 10px", borderRadius: "20px", border: "1px black solid" }} >
                                                            <Spinner variant="dark" />
                                                        </button>
                                                    )
                                                    :
                                                    (
                                                        <button type="submit" onClick={handleSubmit} rows={3} className="text-dark" style={{ background: "white", fontWeight: "bold", padding: "10px 10px 10px 10px", borderRadius: "20px", border: "1px black solid" }} >
                                                            Envoyer le message <IoMdArrowRoundForward color={"#43B613"} />
                                                        </button>
                                                    )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div style={{ position: "absolute", zIndex: 55, top: -90, right: 10 }}>
                                <img src={"design/images/Vector_design.png"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default ContactPage;
